module.exports = __webpack_public_path__ + "img/logo-home-mobile.520ff78b.png";